
import { Outlet } from "react-router-dom";
import { Footer } from "../../components/specific/footer/Footer";
import { Header } from "../../components/specific/header/Header";

export default function PrimaryLayout() {
    return (
        <div className='page page--primary d-flex f-column'>
            <Header />

            <main role="main">
                <Outlet />
            </main>

            <Footer />
        </div>
    )
}
